import React, { useState } from 'react'
import { Button, Dropdown } from 'element-react'
import { Link } from 'react-router-dom'
import SearchForm from '../SearchForm'
import useAuth from '../../../hooks/useAuth'
import useAdmin from '../../../hooks/useAdmin'
import AppRoutes from '../../../routes/appRoutes'
import L1NAdminLogo from '../../../../js/svg/L1N-admin-header-logo.svg'

const createAddUserButton = (sapId, className = '') => (
    <Link to={AppRoutes.adminAddUser(sapId ? '?sapId=' + sapId : '')}>
        <Button type="primary" icon="plus" size="small" className={className}>
            <em>Add User</em>
        </Button>
    </Link>
)

const Header = () => {
    const [isToggleOn, setIsToggleOn] = useState(true)
    const { authenticated, role } = useAuth()
    const { currentCompanySapId } = useAdmin()

    const handleClick = () => {
        setIsToggleOn(prevIsToggleOn => !prevIsToggleOn)
    }

    const addUserButton = createAddUserButton(currentCompanySapId)
    const addUserButtonExpanded = createAddUserButton(
        currentCompanySapId,
        'expanded',
    )

    const createAdminButton = (
        <Link className="block" to={AppRoutes.adminCreateAdmin()}>
            Create Admin User
        </Link>
    )

    const manageAdminsButton = (
        <Link className="block" to={AppRoutes.adminManageAdmins()}>
            Manage Admin Users
        </Link>
    )

    const manageFeatureFlagging = (
        <Link className="block" to={AppRoutes.adminFeatureFlags()}>
            Manage Feature Flags
        </Link>
    )

    const downloadReports = (
        <Link className="block" to={AppRoutes.adminReports()}>
            Download Reports
        </Link>
    )

    const maintenanceStatusButton = (
        <Link className="block" to={AppRoutes.adminMaintenaceStatus()}>
            Maintenance Status
        </Link>
    )

    const logoutButton = (
        <Link className="block" to={AppRoutes.logout()}>
            Logout
        </Link>
    )

    let contents = authenticated ? (
        <div className="row">
            <div className="large-8 medium-7 columns">
                <ul className="menu menu--main">
                    <li className="logo-container">
                        <Link to={AppRoutes.home()} className="logo">
                            <img className="h-10 w-30" src={L1NAdminLogo} />
                        </Link>
                    </li>

                    {/* Dropdown Container for small screens*/}
                    <li className="dropdown-container show-for-small-only">
                        <Dropdown
                            trigger="click"
                            menu={
                                <Dropdown.Menu>
                                    {role === 'admin' ? (
                                        <React.Fragment>
                                            <Dropdown.Item className="add-user">
                                                {addUserButtonExpanded}
                                            </Dropdown.Item>
                                            <hr className="margin-bottom-none" />
                                            <Dropdown.Item>
                                                {maintenanceStatusButton}
                                            </Dropdown.Item>
                                            <Dropdown.Item>
                                                {manageFeatureFlagging}
                                            </Dropdown.Item>
                                            <Dropdown.Item>
                                                {downloadReports}
                                            </Dropdown.Item>
                                            <Dropdown.Item>
                                                {createAdminButton}
                                            </Dropdown.Item>
                                            <Dropdown.Item>
                                                {manageAdminsButton}
                                            </Dropdown.Item>
                                        </React.Fragment>
                                    ) : null}
                                    <Dropdown.Item>
                                        {logoutButton}
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            }
                        >
                            {/* Hamburger Button */}
                            <a
                                className={`lines-button${
                                    isToggleOn ? '' : ' close'
                                }`}
                                onClick={handleClick}
                            >
                                <span className="lines" />
                                <span className="text h6 oil-color">Menu</span>
                            </a>
                        </Dropdown>
                    </li>

                    <li className="search-container">
                        <SearchForm />
                    </li>
                </ul>
            </div>
            <div className="large-4 medium-5 columns hide-for-small-only">
                <ul className="menu menu--sub float-right">
                    {role === 'admin' && <li>{addUserButton}</li>}
                    <li style={{ padding: '0.7rem 0' }}>
                        <Dropdown
                            className="el-dropdown-link"
                            trigger="click"
                            menu={
                                <Dropdown.Menu>
                                    {role === 'admin' ? (
                                        <React.Fragment>
                                            <Dropdown.Item>
                                                {maintenanceStatusButton}
                                            </Dropdown.Item>
                                            <Dropdown.Item>
                                                {manageFeatureFlagging}
                                            </Dropdown.Item>
                                            <Dropdown.Item>
                                                {downloadReports}
                                            </Dropdown.Item>
                                            <Dropdown.Item>
                                                {createAdminButton}
                                            </Dropdown.Item>
                                            <Dropdown.Item>
                                                {manageAdminsButton}
                                            </Dropdown.Item>
                                        </React.Fragment>
                                    ) : null}

                                    <Dropdown.Item>
                                        {logoutButton}
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            }
                        >
                            {/* GEAR Button */}
                            <span
                                className="el-dropdown-link"
                                style={{ cursor: 'pointer' }}
                            >
                                <i className="icon-cog text-xxlarge el-icon--left"></i>
                            </span>
                        </Dropdown>
                    </li>
                </ul>
            </div>
        </div>
    ) : (
        // otherwise, if not authenticated, contents =
        <ul className="menu">
            <li>
                <Link to={AppRoutes.home()}>LiftOne</Link>
            </li>
            <li>
                <Link to={AppRoutes.login()}>Sign In</Link>
            </li>
        </ul>
    )

    return (
        <header className="header--admin">
            <div className="row width120">
                <div className="columns small-12">
                    <nav className="navigation">{contents}</nav>
                </div>
            </div>
        </header>
    )
}

export default Header
